/**
 * 베타 무료 공지 API 파사드(specs/036) — 계약: `specs/036-beta-free-period/contracts/beta-free-period-api.md` §FO.
 * 비로그인 방문자도 조회한다(익명). 노출 판단(진행 중 여부)은 서버가 소유한다.
 */
import { http, withErrors } from './http';

export interface BetaFreePeriod {
  /** 베타 무료 종료일(KST 날짜 `YYYY-MM-DD`). 진행 중이 아니면 null */
  betaFreeUntil: null | string;
}

/** 메인 공지용 — 실패해도 공지만 숨기면 되므로 무음. */
export async function getBetaFreePeriod(): Promise<BetaFreePeriod> {
  const { data } = await http.get<BetaFreePeriod>(
    '/fo/beta-free-period',
    withErrors({ silent: true }),
  );
  return data;
}
